import React from "react";
import { FileUploader } from "react-drag-drop-files";
import Progress from "react-progressbar";
import Modal from "react-bootstrap/Modal";
import { PDFTypeIcon } from "../../Static/icons/iconshere";

const MediaGalleryModal = ({
  mediaGalleryShow,
  GalleryClose,
  fileTypes,
  handleProductImageChange,
  allSavedFileUrl,
  deleteProductImage,
  uploadedProductFiles,
  saveProductImagesFile,
  multipleUpload = true,
  maxFileSize = 10,
  showCloseButton = true,
  onlyView= false,
  fileUploadError=null
}) => {

  const renderPreviewCard = (upload, listKey, showProgress = false, classSuffix = "") => {
    const fileUrl = upload?.url || "";
    const extension = fileUrl.split(".").pop().toLowerCase();
    const commonClass = `prdimgprw${classSuffix ? ` ${classSuffix}` : ""}`;

    let previewContent = null;

    if (extension === "mp4") {
      previewContent = (
        <video width="113" height="115" controls className={commonClass}>
          <source src={fileUrl} type="video/mp4" />
          <source src={fileUrl} type="video/ogg" />
          Your browser does not support the video tag.
        </video>
      );
    } else if (extension === "pdf") {
      previewContent = (
        <div className={`arePDFDisplay ${commonClass} `}>
          {" "}
          <PDFTypeIcon />{" "}
        </div>
      );
    } else {
      previewContent = <img className={commonClass} src={fileUrl} alt="image" />;
    }

    return (
      <div className="uploadImageProcess" key={fileUrl + listKey}>
        <div className="productimgprev">
          {previewContent}
          {fileUrl && !onlyView && <i className="bi bi-x" title="delete" onClick={() => deleteProductImage(listKey, fileUrl)}></i>}
        </div>
        {showProgress && upload.progress < 100 && <Progress completed={upload.progress} />}
      </div>
    );
  };

  return (
    <div>
      <Modal size="lg" centered show={mediaGalleryShow} onHide={GalleryClose}>
        <Modal.Header closeButton>Upload Media Gallery (Max file size: {maxFileSize}MB) </Modal.Header>

        <div className="modal-body productimages">
          <div className="container-fluid">
          { !onlyView &&
            <div className="row">
              <div className="col-md-12 p-1">
                <div className="fileuploader popup">
                  <FileUploader
                    name="productFileInputs"
                    multiple={multipleUpload}
                    types={fileTypes}
                    label={`drag & drop or choose file to upload (Max file size: ${maxFileSize}MB)`}
                    handleChange={handleProductImageChange}
                    className="w-100"
                    {...(maxFileSize && {
                      maxSize: maxFileSize,
                    })}
                  />
                </div>
              </div>
              <p className="error" >{fileUploadError}</p>
            </div>}

            <div className="row">
              <div className="productthumbnail">
                {allSavedFileUrl?.map((upload) => renderPreviewCard(upload, "allSavedFileUrl", false, "prdimgprw"))}

                {uploadedProductFiles.map((upload) =>
                  renderPreviewCard(upload, "uploadedProductFiles", true, "prdimgprwblr")
                )}
              </div>
            </div>

            {/* <div className="media-list">
              <div className="table-responsive workflowtb mt-2 stickyhead mb-0 mt-0">
                <table className="table align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th className="text-center">S.No</th>
                      <th className="text-center">File Name</th>
                      <th className="text-center">File Type</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="versiontable">
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                    <tr>
                      <td className="text-center "> 01 </td>
                      <td className="text-center"> File Name </td>
                      <td className="text-center"> Image </td>
                      <td className="text-center versiontag">Download</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> */}
          </div>
        </div>

        <div className="col-12">
          <div style={{ padding: "1rem" }} className="footerbtn text-end">
           {showCloseButton && <button type="button" className="btn btn-secondary" onClick={GalleryClose}>
              Close
            </button>}
            <button type="button" className="btn btn-primary" onClick={saveProductImagesFile}>
              Done
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MediaGalleryModal;
